document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartFooter', (context) => {
    return {
      context: context,
      footerRoot: null,
      drawer_section: '',
      _cartForm() {
        const cartPanel = this.footerRoot.closest('[data-modal-label]');
        return (
          (cartPanel && cartPanel.querySelector('form[action*="/cart"]')) ||
          document.querySelector('form#cart')
        );
      },
      _morphFooter(e) {
        const newFooterSection = querySelectorInHTMLString(
          '[data-cart-footer]',
          e.detail.response.sections[this.drawer_section]
        );

        Alpine.morph(
          this.footerRoot,
          newFooterSection ? newFooterSection.outerHTML : '',
          {
            updating(el, toEl, childrenOnly, skip) {
              if (
                el.classList &&
                el.classList.contains('additional-checkout-buttons')
              ) {
                skip();
              }
            },
          }
        );
      },
      checkout(e) {
        if (e) e.preventDefault();

        const form = this._cartForm();

        if (!form) {
          window.location.href = '/checkout';
          return;
        }

        let checkoutInput = form.querySelector(
          '[data-cart-checkout-submit]'
        );

        if (!checkoutInput) {
          checkoutInput = document.createElement('input');
          checkoutInput.type = 'hidden';
          checkoutInput.name = 'checkout';
          checkoutInput.value = 'checkout';
          checkoutInput.setAttribute('data-cart-checkout-submit', '');
          form.appendChild(checkoutInput);
        }

        form.submit();
      },
      init() {
        this.footerRoot = this.$root;

        if (context === 'drawer') {
          this.drawer_section = 'drawer-cart-footer';
        } else {
          this.drawer_section = 'cart-footer';
        }

        window.addEventListener('switch:cart:afteradditem', (e) => {
          this._morphFooter(e);
        });

        window.addEventListener('switch:modalcart:cartqtychange', (e) => {
          this._morphFooter(e);
        });
      },
    };
  });
});
